import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import mixin from './mixin';

export default {
  data: function data() {
    return {
      isOpenSucker: false, // 是否处于吸管状态
      isSucking: false // 是否处于吸管等待状态
    };
  },

  mixins: [mixin],
  methods: {
    openSucker: function openSucker() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var eyeDropper, result, _setColorValue, r, g, b, a;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.isOpenSucker) {
                  _context.next = 19;
                  break;
                }

                _this.isOpenSucker = true;
                _this.isSucking = true;
                _this.$emit('openSucker', true);
                _context.prev = 4;

                // eslint-disable-next-line no-undef
                eyeDropper = new EyeDropper();
                _context.next = 8;
                return eyeDropper.open();

              case 8:
                result = _context.sent;

                // The user selected a pixel, here is its color:
                _this.isSucking = false;
                _this.isOpenSucker = false;

                _setColorValue = _this.setColorValue(result.sRGBHex), r = _setColorValue.r, g = _setColorValue.g, b = _setColorValue.b, a = _setColorValue.a;


                _this.$emit('selectSucker', { r: r, g: g, b: b, a: a }, result);
                _context.next = 19;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](4);

                // The user escaped the eyedropper mode.
                _this.isSucking = false;
                _this.isOpenSucker = false;

              case 19:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[4, 15]]);
      }))();
    }
  }
};